export default __webpack_public_path__ + "static/media/application_history_green.f52a612c.svg";